import React from 'react';

import { Box, Button, Typography } from '@mui/material';

export const AppCrashSection: React.FC = () => {
  const [brokenComponentRendered, setBrokenComponentRendered] = React.useState(false);

  const handleClick = () => {
    setBrokenComponentRendered(true);
  };

  return (
    <Box component="section">
      <Typography variant="h3">Crash application</Typography>

      <Box mt={2}>
        <Button variant="contained" onClick={handleClick}>
          Crash application
        </Button>
      </Box>

      {brokenComponentRendered && <BrokenComponent />}
    </Box>
  );
};

const BrokenComponent: React.FC = () => {
  throw new Error('I am broken :(');
};
